/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard PRO React layouts
import React from "react";
import HouseIcon from "@mui/icons-material/House";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PersonIcon from "@mui/icons-material/Person";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { AllProducts } from "./layouts/ecommerce/product/all-products/all-products";
import Illustration from "layouts/authentication/sign-in/illustration";
import LoginPage from "layouts/ecommerce/product/all-products/LoginPage";
import { ProductsPage } from "./layouts/ecommerce/product/all-products/ProductsPage";
const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "Home",
    route: "/signIn",
    icon: <HouseIcon />,
    noCollapse: true,
    component: <LoginPage />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/abc",
    icon: <LocalOfferIcon />,
    noCollapse: true,
    component: <Illustration />,
  },
  {
    type: "collapse",
    name: "All Products",
    key: "Products",
    route: "/restaurant/cart",
    icon: <LocalOfferIcon />,
    noCollapse: true,
    component: <ProductsPage />,
  },
  {
    type: "collapse",
    name: "LogOut",
    key: "reports",
    icon: <PowerSettingsNewIcon />,
    route: "/setting/overview",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Active Order",
    key: "reports",
    icon: <PowerSettingsNewIcon />,
    route: "/activeorder/overview",
    noCollapse: true,
  },
];

export default routes;
